module.exports = __webpack_public_path__ + "img/friend-1.fba8dd5d.png";